import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getUserFullName',
})
export class GetUserFullNamePipe implements PipeTransform {
  transform(obj: any): any {
    let res = '';
    if (obj && obj.firstName) {
      res += obj.firstName + ' ';
    }
    if (obj && obj.lastName) {
      res += obj.lastName + ' ';
    }
    return res;
  }
}
